'use strict';

angular.module('ListAccessRequestControllers')

.controller('MainAccessRequestCtrl', ['$scope', '$q', '$state', '$translate', 'authenticatedUser', 'enoughRights', 'topBar', function ($scope, $q, $state, $translate, authenticatedUser, enoughRights, topBar) {

    if (enoughRights == false) {
        $state.go('home');
    }

    $translate('iam.userRequest.pageTitle').then(function(translation) {
        topBar.setTitleAndIcon(translation, 'fa-inbox');
    });

    $scope.currentIdentity = authenticatedUser.IdentityName;

    if ($state.is('userAccessRequest')) {
        $state.go('userAccessRequest.request.all');
        return;
    }
}]);
